const fetchApi = (path, method, body) => {

    let basePath = 'https://acuadori.abinsula.com/api/';
    let url;

    if (path.includes("http://") || path.includes("https://")) {
        url = path;
    }
    else {
        url = basePath + path;
    }

    const requestOptions = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'X-Authorization': 'Bearer ' + window.localStorage.getItem('auth_token'),
        },
        body: body
    };
    return callApi(url, requestOptions);
};

const callApi = (path, requestOptions) => {

    return fetch(path, requestOptions)
        .then((response) => {

            if (!response.ok) {
                console.log(response);
                return response.json().then((res) => { throw res });
            }

            let contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return response.json();
            } else {
                return response.text();
            }

        });
}

class Service {

    updateState = (obj) => { };

    getRoutes = () => { return ({}); }


    constructor(storage = (() => { }), getUrlCbk = (() => ''), getAuthCbk = (() => ''), errorHandler = (resp) => { return {} }) {
        this.storage = storage;
        this.getUrl = getUrlCbk;
        this.getAuth = getAuthCbk;
        this.errorHandler = errorHandler;
    }

    url = (subPath) => subPath ? this.getUrl() + subPath : this.getUrl();

    headers = () => {
        return {
            'Content-Type': 'application/json',
            'X-Authorization': 'Bearer ' + this.getAuth(),
        }
    }

    options = (method, body) => {
        return {
            method: method,
            headers: this.headers(),
            body: body
        }
    }

    setUpdateStateCbk = (callback) => this.updateState = callback;

    GET(subPath, body = null) { return this.fetchApi(subPath, 'GET', body) }
    POST(subPath, body) { return this.fetchApi(subPath, 'POST', body) }
    QUERY(subPath, queryObject, body = null) {
        const keyValuePairs = [];
        for (const key in queryObject) {
            keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryObject[key]));
        }
        let params = keyValuePairs.join('&');
        let query = (params.length > 0) ? subPath + '?' + params : subPath;
        return this.GET(query, body);
    }

    fetchApi = (subPath, method, body) => {

        const url = this.url(subPath);
        const requestOptions = this.options(method, body);

        return this.callApi(url, requestOptions);
    }

    callApi = (path, requestOptions) => {

        return fetch(path, requestOptions)
            .then((response) => {

                if (!response.ok) {
                    return response.text().then((text) => {
                        let res;
                        try {
                            res = text ? JSON.parse(text) : {};
                        }
                        catch (error) {
                            res = { message: text };
                        }

                        res.status = res.status || response.status;
                        res.message = res.message || response.statusText || `HTTP ${response.status}`;

                        if (this.errorHandler) {
                            this.errorHandler(res);
                        }
                        else {
                            throw res;
                        }
                    });
                }

                let contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json();
                } else {
                    return response.text ? response.text() : "Error!";
                }

            })
    }

}

export default Service;

export {
    Service,
    fetchApi,
    callApi
}
